import { useEffect, useMemo } from 'react'
import { useBinsStore } from '../lib/state'
import { Assignation } from '../../../context/types'

export const computePages = (
    binStms: Assignation[],
    page: number,
    maxPerPage: number
) => {
    const stmsTotal = binStms.length ?? 0
    const nPage = Math.ceil(stmsTotal / maxPerPage)
    
    const stmsForPage = binStms.slice(
        page * maxPerPage,
        (page + 1) * maxPerPage
    ) ?? [];
    const stmsUnExplored = binStms.slice(
        (page + 1) * maxPerPage,
        stmsTotal
    ) ?? [];

    const stmsForPageTotal = stmsForPage.length
    const stmsOnPrevPages = page * maxPerPage
    const stmsExploredTotal = stmsOnPrevPages + stmsForPageTotal

    return {
        stmsForPage,
        stmsUnExplored,
        stmsExploredTotal,
        stmsTotal,
        nPage,
    }
}

export const usePaginatedBin = () => {
    const { bins, selectedBinRef, page, setPage, maxPerPage } = useBinsStore()

    const selectedBin = useMemo(
        () => (selectedBinRef ? bins[selectedBinRef] : null),
        [bins, selectedBinRef]
    )

    const {
        stmsForPage,
        stmsExploredTotal,
        stmsTotal,
        nPage,
    } = useMemo(
        () => computePages(selectedBin?.stms ?? [], page, maxPerPage),
        [selectedBin, page, maxPerPage]
    )

    useEffect(() => {
        if (stmsForPage.length === 0 && page > 0) {
            setPage(page - 1)
        }
    }, [stmsForPage.length])

    useEffect(() => {
        setPage(0)
    }, [selectedBinRef])

    return {
        stmsForPage,
        stmsExploredTotal,
        stmsTotal,
        nPage,
        page,
        setPage,
        maxPerPage,
    } // FIXME use PaginatedState type
}
